import React, { useState } from 'react';
import { DialogComponent, Tables } from '../../../../../../Components';
import { TableActions } from '../../../../../../Enums';
import CampaignConfigurationFields from './CampaignConfigurationFields';
import { showError } from '../../../../../../Helper';
import { ButtonBase } from '@material-ui/core';
import {
  DeleteCampaignCommissionOverride,
  UpdateCampaignCommissionOverride,
} from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import DeleteEntityDialog from '../../GeneralConfiguration/Components/DeleteEntityDialog';

const headerData = [
  { label: 'Entity', input: 'entityName' },
  { label: 'Campaign name', input: 'campaignName' },
  {
    label: 'Commission Type',
    component: (item) =>
      item.commissionType === 2 ? 'Percentage (%)' : 'Fixed Amount (AED)',
  },
  { label: 'Commission', input: 'commissionValue' },
];
export default function CampaignConfigurationTable({
  parentTranslationPath,
  translate,
  campaignOverrides,
  setCampaignOverrides,
  state,
  setState,
  selectedValue,
  setSelectedValue,
  reload,
  entitySources,
}) {
  const [editEntity, setEditEntity] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [deleteEntity, setDeleteEntity] = useState(null);
  const onActionClicked = (actionEnum, item) => {
    if (actionEnum === TableActions.edit.key) {
      setActiveItem(item);
      setEditEntity(true);
    }
    if (actionEnum === TableActions.delete.key) {
      setActiveItem(item);
      setDeleteEntity(true);
    }
  };

  const handleSaveChanges = async () => {
    try {
      await UpdateCampaignCommissionOverride(state);
      setEditEntity(false);
      setActiveItem(null);
      reload();
    } catch {
      showError('something went wrong');
    }
  };

  const handleCloseDialog = () => {
    setEditEntity(false);
    setActiveItem(null);
    setSelectedValue({
      entitySource: {},
      commissionType: null,
      commissionValue: '',
      campaignOverrides: {},
    });
    setState({
      leadXchangeEntitySourceId: null,
      campaignName: null,
      commissionType: null,
      commissionValue: null,
    });
  };

  const handleDeleteEntity = async (activeItem) => {
    const id = activeItem.campaignCommissionOverrideId;
    try {
      await DeleteCampaignCommissionOverride(id);
      reload();
    } catch {
      showError('something went wrong');
    }
  };
  return (
    <div className='w-75'>
      <Tables
        data={campaignOverrides}
        headerData={headerData}
        defaultActions={[
          { enum: TableActions.edit.key },
          { enum: TableActions.delete.key },
        ]}
        actionsOptions={{ onActionClicked }}
        parentTranslationPath={parentTranslationPath}
        activePage={0}
      />
      {editEntity && (
        <DialogComponent
          isOpen
          titleText={'Edit Campaign configuration'}
          maxWidth={'sm'}
          onCloseClicked={handleCloseDialog}
          wrapperClasses={'entity-dialog-wrapper'}
          parentTranslationPath={parentTranslationPath}
          dialogContent={
            <div className='entity-dialog-content'>
              <CampaignConfigurationFields
                parentTranslationPath={parentTranslationPath}
                translate={translate}
                entitySources={entitySources}
                setState={setState}
                state={state}
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                activeItem={activeItem}
                campaignOverrides={campaignOverrides}
              />
            </div>
          }
          dialogActions={
            <div className='entity-dialog-actions'>
              <ButtonBase
                className='btns theme-propx outlined'
                onClick={handleCloseDialog}
              >
                Cancel
              </ButtonBase>
              <ButtonBase
                className='btns theme-propx solid'
                onClick={() => {
                  handleSaveChanges();
                }}
              >
                Save changes
              </ButtonBase>
            </div>
          }
        />
      )}
      {deleteEntity && (
        <DeleteEntityDialog
          isOpen
          parentTranslationPath={parentTranslationPath}
          onClose={() => {
            setDeleteEntity(false);
            setActiveItem(null);
          }}
          activeItem={activeItem}
          handleDeleteFunction={handleDeleteEntity}
        />
      )}
    </div>
  );
}
